import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Stack, Typography } from '@mui/material';
import { AppBarButton } from './AppBarButton';
import { useAuth } from '../../auth/AuthContext';
import UserAuthenticated from '../../auth/UserAuthenticated';

const MenuAppBar = ({ ristoranteId }: { ristoranteId: string }) => {
    const url = window.location.href;

    let { isAuthenticated } = useAuth();

    return (
        <AppBar
            color={'default'}
            style={{ backgroundColor: 'white', border: 'none', height: 54 }}
            variant="outlined"
            position="relative"
            sx={{
                width: "100%",
                flex: 1,
                borderBottom: "1px solid #ececf1 !important",
                zIndex: 100
            }}
        >
            <Toolbar sx={{
                minHeight: "54px !important",
                width: "100%",
                justifyContent: "space-between",
            }}>

                <Stack>
                    <Typography></Typography>
                </Stack>
                <Stack sx={{
                    flex: 1,
                    alignItems: "flex-end",
                }}>
                    {
                        isAuthenticated && (
                            <Stack
                                direction="row"
                                gap={1}
                                alignItems="center"
                                style={{ float: 'right', marginRight: 0 }}
                            >
                                {
                                    UserAuthenticated.getInstance().abilitaModuloChat && (
                                        <AppBarButton
                                            url={`/chat/${ristoranteId}`}
                                            selected={url.includes('/chat')}
                                        >
                                            Chat
                                        </AppBarButton>
                                    )
                                }
                                <AppBarButton url={`/bi/${ristoranteId}/pl`} selected={url.includes('/bi')}>
                                    Business Intelligence
                                </AppBarButton>
                                <AppBarButton
                                    url={`/myAccount/${ristoranteId}/anagraficaArticoli`}
                                    selected={url.includes('/myAccount')}
                                >
                                    Amministrazione
                                </AppBarButton>
                                {
                                    UserAuthenticated.getInstance().abilitaModuloServizio && (
                                        <AppBarButton
                                            url={`/servizio/${ristoranteId}/cameriere`}
                                            selected={url.includes('/servizio')}
                                        >
                                            Servizio
                                        </AppBarButton>
                                    )
                                }
                                <AppBarButton
                                    url={`/impostazioni/${ristoranteId}/info`}
                                    selected={url.includes('/impostazioni')}
                                >
                                    Impostazioni
                                </AppBarButton>
                            </Stack>
                        )
                    }
                </Stack>
            </Toolbar>
        </AppBar >
    );
};

export default MenuAppBar;
